import React, { Fragment } from 'react'
import { Breadcrumb, Button, Card, Col, Popconfirm, Row } from 'antd'
import style from '../../style.css'
import PaymentForm from '../../../../components/Sales/Payments/PaymentForm'
import InvoicesList from '../../../../components/Sales/Payments/InvoicesList'
import useTitle from '../../../../elements/Hooks/useTitle'

function AddReceipt (props) {
  const {
    fetching,
    type,
    receipt,
    transaction,
    submitting,
    removing,
    submit,
    update,
    remove,
    formRef,
    fetchingTransaction,
    fetchingReceipt,
  } = props
  useTitle('Create New Receipt')
  return (
    <Fragment>
      <Card loading={fetching}>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Sales</Breadcrumb.Item>
            <Breadcrumb.Item href="#/clients/payments/#receipts">Receipts</Breadcrumb.Item>
            <Breadcrumb.Item>{receipt.code}</Breadcrumb.Item>
          </Breadcrumb>
          <h2 className={style.title}>{type !== 'edit' ? 'Create a Receipt' : 'Update Receipt'}</h2>
          <p className={style.paragraph}>
            {type !== 'edit'
              ? 'You can add new Receipt by following the steps below.'
              : 'You can edit Receipt by following the steps below.'}
          </p>
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <PaymentForm
          ref={formRef}
          transaction={transaction}
          loading={fetchingTransaction || fetchingReceipt}
          {...props}
        />
        {(type === 'edit' && receipt.status === 'Draft') || type === 'new' ? (
          <Row style={{ marginTop: '20px' }}>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Popconfirm
                //placement="top"
                title={
                  'Any Remaining Transaction Amount will be added as a deposit to the account.\nDo you want to Proceed ?'
                }
                onConfirm={type !== 'edit' ? submit : update}
                okText="Yes"
                cancelText="No">
                <Button
                  loading={submitting}
                  type="primary"
                  //onClick={type !== 'edit' ? submit : update}
                >
                  {type === 'edit' ? 'Update' : 'Submit'}
                </Button>
              </Popconfirm>
            </Col>
          </Row>
        ) : null}
        <InvoicesList {...props} />
        {(type === 'edit' && receipt.status === 'Draft') || type === 'new' ? (
          <Row style={{ marginTop: '20px' }}>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Popconfirm
                //placement="top"
                title={
                  'Any Remaining Transaction Amount will be added as a deposit to the account.\nDo you want to Proceed ?'
                }
                onConfirm={type !== 'edit' ? submit : update}
                okText="Yes"
                cancelText="No">
                <Button
                  loading={submitting}
                  type="primary"
                  //onClick={type !== 'edit' ? submit : update}
                >
                  {type === 'edit' ? 'Update' : 'Submit'}
                </Button>
              </Popconfirm>
            </Col>
          </Row>
        ) : null}
      </Card>
    </Fragment>
  )
}

AddReceipt.propTypes = {}
AddReceipt.defaultProps = {}

export default AddReceipt
